import React, {Fragment, useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {useLoadingStore} from "@/stores/loading";
import {useMessageModalStore} from "@/stores/message";
import * as Config from "@/config";
import {axios} from '@/lib/axios'

export default function Forgot(props: { type: Config.Forgot }) {
  const navigate = useNavigate();
  const setLoading = useLoadingStore((state) => state.setLoading);
  const setMessage = useMessageModalStore((state) => state.setMessage);
  const [loginId, setLoginId] = useState("");
  const [email, setEmail] = useState("");

  const onClickSend = () => {
    setLoading(true);
    const api = props.type === Config.Forgot.LoginId ?
      '/api/v1/customers/forgotLoginId' : '/api/v1/customers/forgotPassword';
    axios.post(api, {
      login_id: loginId,
      email: email,
    })
      .then((res) => {
        console.log(res.data);
        setMessage("メールを送信しました。");
      })
      .catch((error) => {
        console.log(error);
        setMessage(error.response.data.message ?? Config.MESSAGE_NO_E39);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="login-container uk-width-1-1">
      <div className="login-item">
        <div className="login-item-header">
          <p>メールアドレス入力</p>
        </div>
        <div className="login-item-body login-item-body-login">
          <div className="message">
            {props.type === Config.Forgot.LoginId ?
              "ログインIDを忘れた方は、登録したメールアドレスを入力してください。メールアドレス宛にログインIDを記載したメールをお送りします。"
              :
              "パスワードを忘れた方は、登録したメールアドレスを入力してください。メールアドレス宛にパスワード再設定用のURLをお送りします。"
            }
          </div>
          {props.type === Config.Forgot.Password && <p className="error mt-0">パスワード変更するとDRM-PFのパスワードも同時に変更されます。</p>}
          {props.type === Config.Forgot.Password &&
              <div className="mailadress">
                  <p>ログインID</p>
                  <input
                      className="uk-input uk-form-small mailadress-form"
                      type="text"
                      value={loginId}
                      onChange={(e) => setLoginId(e.target.value)}
                  />
              </div>
          }
          <div className="mailadress">
            <p>メールアドレス</p>
            <input
              className="uk-input uk-form-small mailadress-form"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="uk-flex uk-flex-center uk-margin-small-top">
            <button
              onClick={onClickSend}
              className="uk-button--l uk-button-refer"
            >
              送信
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
